import { render, staticRenderFns } from "./CatalisadoresPecasSelectUsuario.vue?vue&type=template&id=4408a688&"
import script from "./CatalisadoresPecasSelectUsuario.vue?vue&type=script&lang=ts&"
export * from "./CatalisadoresPecasSelectUsuario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VIcon,VTextField})
